import QuizActions from '../actions/quizActions';

function quizReducer(state = {
    proctoringKey : {},
    errorInProctoringKey : false,
    errorInProctoringKeyMessage : null,
    networkErrorInProctoringKey : false,

    startQuiz : {},
    errorInQuizStart : false,

    continueQuiz : {},
    errorInContinueQuiz : false,

    submitAnswer : {},
    showResult : {},
    isErrorInShowResult : false,

    isLoading : false,

    deleteAnswerSheet : {},
    errorInDeleteAnswerSheet : false

}, action) {

    switch(action.type){
        case QuizActions.proctorKey :
            return {
                ...state,
                proctoringKey : action.data,
                errorInProctoringKey : false,
                startQuiz : {}
            }
        case QuizActions.errorInProctorKey :
            return {
                ...state,
                errorInProctoringKey : true,
                errorInProctoringKeyMessage: action.data.error,
                proctoringKey : {},
                startQuiz : {}
            }
        case QuizActions.networkErrorInProctorKey :
            return {
                ...state,
                errorInProctoringKey : false,
                networkErrorInProctoringKey : action.data,
                proctoringKey : {}
            }
        case QuizActions.clearProctorKey :
            return {
                ...state,
                errorInProctoringKey : false,
                proctoringKey : {},
                continueQuiz : {}
            }    
        case QuizActions.deleteAnswerSheet :
            return {
                ...state,
                deleteAnswerSheet : action.data,
                errorInDeleteAnswerSheet : false
            }
        case QuizActions.deleteAnswerSheetFailed :
            return {
                errorInDeleteAnswerSheet : true,
                deleteAnswerSheet : {}
            }
        case QuizActions.clearDeleteAnswerSheet :
            return {
                ...state,
                deleteAnswerSheet : {}
            }
        case QuizActions.startQuiz :
            return {
                ...state,
                startQuiz : action.data,
                proctorKey : {},
                errorInQuizStart : false
            }
        case QuizActions.errorInQuizStart :
            return {
                ...state,
                errorInQuizStart : true,
                proctorKey : {},
                startQuiz : {}
            }
        case QuizActions.continueQuiz :
            return {
                ...state,
                continueQuiz : action.data,
                proctorKey : {},
                errorInContinueQuiz : false
            }
        case QuizActions.errorInContinueQuiz :
            return {
                ...state,
                errorInContinueQuiz : true,
                proctorKey : {},
                continueQuiz : {}
            }
        case QuizActions.submitAnswer :
            return {
                ...state,
                submitAnswer : action.data,
            }
        case QuizActions.showResult :
            return {
                ...state,
                isErrorInShowResult : false,
                showResult : {}
            }
        case QuizActions.showResultSuccess :
            return {
                ...state,
                showResult : action.data,
                isErrorInShowResult : false,
                isLoading : false,
                errorInContinueQuiz : false
            }
        case QuizActions.showResultFailed :
            return {
                ...state,
                showResult : {},
                isErrorInShowResult : true
            }
        default:
            return state;
    }
}

export default quizReducer;


// WEBPACK FOOTER //
// ./src/store/reducer/quizreducer.js